import type { RadioOptionType } from '@openx/components-core/lib/RadioField/types.ts';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useFixedCpmEnabledOptions = () => {
  const { t } = useTranslation();

  const fixedCpmEnabledOptions = useMemo<RadioOptionType<boolean>[]>(
    () => [
      {
        label: t('Dynamic floor'),
        tooltip: t(
          'OpenX calculates the final deal floor for each bid request based on market conditions. The final floor may be higher than the deal price entered here.'
        ),
        tooltipPlacement: 'right',
        value: false,
        dataTest: 'dynamic-floor',
      },
      {
        label: t('Fixed price'),
        tooltip: t(
          'The deal price is fixed and sent to DSPs as the floor. Buyers pay this CPM even if they bid higher. The deal will only match inventory where the publisher hard floor is at or below the deal price.\n'
        ),
        tooltipPlacement: 'right',
        value: true,
        dataTest: 'fixed-price',
      },
    ],
    [t]
  );

  return {
    fixedCpmEnabledOptions,
  };
};
